import React, {useEffect, useState} from 'react';
import { Modal, Button } from 'react-daisyui';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface FormConfirmModalProps {
  isOpen: boolean;
  closeModal: () => void;
  handleConfirm: any;
  actionDescription: string;
}

const FormConfirmModal: React.FC<FormConfirmModalProps> = ({
  isOpen,
  closeModal,
  handleConfirm,
  actionDescription
}) => {
  const [loading, setLoading] = useState(false); 

  useEffect(() => {
    isOpen && setLoading(false);
  }, [isOpen])

  const handleClick = () => {
    setLoading(true)
    handleConfirm();
  }

  return (
    <Modal open={isOpen} >
      <Modal.Header className="font-bold">
        Confirm {actionDescription}
      </Modal.Header>

      <Modal.Body>
        <div>
          Are you sure you want to {actionDescription.toLowerCase()}?
        </div>
      </Modal.Body>

      <Modal.Actions>
        <Button id='ModalCancelButton' type='button' disabled={loading} onClick={closeModal}>
          Cancel
        </Button>
        <Button
             id='ModalConfirmButton'
            type='button' 
            color="primary"
            className={loading ? "pointer-events-none" : ""} // Disable button while processing
            onClick={loading ? undefined : handleClick} // If processing, do nothing
          >
            {loading ? (
              <div className="flex items-center">
                {/* <span className="loading loading-dots loading-md"></span> */}
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Loading...
              </div>
            ) : (
              "Confirm"
            )}
          </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default FormConfirmModal;
